export default "__VITE_ASSET__DgPWwFwv__"